import { call, put, select, takeEvery } from 'redux-saga/effects';
import { actions, actionTypes } from './modules';
import { apiServiceAsync } from '../services/apiService';
import { eventAnalyticsFiltersStateSelector, eventStandingsListStateSelector } from './selectors';
import _ from 'lodash';

function* loadEventStandingsSaga(action: any): any {
  const currentState = yield select(eventStandingsListStateSelector);

  const isOnlyPageChanged = _.isEqual(_.omit(currentState.ui, 'rankingsPage'), _.omit(action.payload, 'rankingsPage'));

  try {
    yield actions.setRequestPending(true);

    yield put(
      actions.loadEventStandingsList({
        isLoaded: false,
        isLoading: true,
        data: isOnlyPageChanged ? currentState.data : undefined,
        ui: action.payload
      })
    );

    const data = yield call(apiServiceAsync.getEventStandings, action.payload);

    yield put(
      actions.loadEventStandingsList({
        data: data,
        ui: action.payload,
        isLoaded: true,
        isLoading: false
      })
    );
  } catch (error) {
    console.error('Error in loadEventStandingsSaga', error);

    yield put(
      actions.loadEventStandingsList({
        isLoaded: true,
        isLoading: false,
        data: undefined,
        ui: action.payload
      })
    );
  }
}

function* loadEventStandingsFiltersSaga(action: any): any {
  try {
    yield actions.setRequestPending(true);

    yield put(
      actions.loadEventStandingsFilters({
        isLoaded: false,
        isLoading: true,
        collections: []
      })
    );

    const data = yield call(apiServiceAsync.getEventStandingsFilters, action.payload);

    yield put(
      actions.loadEventStandingsFilters({
        collections: data.collections,
        isLoaded: true,
        isLoading: false
      })
    );
  } catch (error) {
    console.error('Error in loadEventStandingsFiltersSaga', error);

    yield put(
      actions.loadEventStandingsFilters({
        isLoaded: false,
        isLoading: false,
        collections: []
      })
    );
  }
}

function* loadEventAnalyticsFiltersSaga(action: any): any {
  const filters = yield select(eventAnalyticsFiltersStateSelector);

  try {
    yield actions.setRequestPending(true);

    yield put(
      actions.loadEventAnalyticsFilters({
        isLoaded: false,
        isLoading: true,
        teams: [],
        zoneIds: [],
        affixes: [],
        ui: action.payload,
        collections: filters.collections,
        brackets: filters.brackets
      })
    );

    const data = yield call(apiServiceAsync.getEventAnalyticsFilters, action.payload);
    yield put(
      actions.loadEventAnalyticsFilters({
        isLoaded: true,
        isLoading: false,
        teams: data.teams,
        zoneIds: data.zoneIds,
        affixes: data.affixes,
        ui: action.payload,
        collections: data.collections,
        brackets: data.brackets
      })
    );
    yield actions.setRequestPending(false);
  } catch (error) {
    yield actions.setRequestPending(false);
  }
}

function* watchRequestLoadEventStandings(): any {
  yield takeEvery(actionTypes.GET_EVENT_STANDINGS_LIST, loadEventStandingsSaga);
}

function* watchRequestLoadEventStandingsFilters(): any {
  yield takeEvery(actionTypes.GET_EVENT_STANDINGS_FILTERS, loadEventStandingsFiltersSaga);
}

function* watchRequestLoadEventAnalyticsFilters() {
  yield takeEvery(actionTypes.GET_EVENT_ANALYTICS_FILTERS, loadEventAnalyticsFiltersSaga);
}

export default [
  watchRequestLoadEventStandings(),
  watchRequestLoadEventStandingsFilters(),
  watchRequestLoadEventAnalyticsFilters()
];
